module.exports = __webpack_public_path__ + "static/media/test4_1.2ee4faba.png";